import React, { useMemo } from 'react';
import { graphql, useFragment } from 'react-relay';

import { UniversalCreate } from '@atlassian/jira-navigation-apps-topnav4-universal-create/src/UniversalCreate.tsx';
import { Create } from './main.tsx';

import type { UniversalCreateOrDefaultButton_fragment$key } from './__generated__/UniversalCreateOrDefaultButton_fragment.graphql.ts';

// TODO: exact allowed apps to be confirmed
const ALLOWED_APPS = ['software'];

type UniversalCreateOrDefaultButtonProps = {
	queryRef?: UniversalCreateOrDefaultButton_fragment$key;
};

export function UniversalCreateOrDefaultButton({ queryRef }: UniversalCreateOrDefaultButtonProps) {
	const data = useFragment(
		graphql`
			fragment UniversalCreateOrDefaultButton_fragment on Query {
				jira_projectByIdOrKey(cloudId: $cloudId, idOrKey: $projectKey)
					@skip(if: $skipUniversalCreateQuery)
					@required(action: THROW) {
					projectType @required(action: THROW)
				}
			}
		`,
		queryRef,
	);

	const projectType = data?.jira_projectByIdOrKey?.projectType?.toLowerCase();

	// TODO: common screens to be confirmed
	const isUniversalCreateEnabled = useMemo(() => {
		// Show the universal create button only for allowed apps
		return projectType && ALLOWED_APPS.includes(projectType);
	}, [projectType]);

	return isUniversalCreateEnabled ? <UniversalCreate /> : <Create />;
}
